// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"311":"6b3e69f4","778":"5eb47a9e","787":"79886a8e"}[chunkId] + ".chunk.js";
};